@use 'src/globals/main';

pn-multiselect {
  display: inline-block;
}

pn-multiselect .pn-multiselect {
  border: 0;
  margin: 0;
  padding: 0;

  &[data-icon] .pn-multiselect-element {
    padding-left: 3em;
  }

  &[data-error] .pn-multiselect-element {
    padding-right: 5.5em;
    @include main.pn-input-field-error();
  }

  &-label {
    @include main.pn-input-label;
    width: 100%;
  }

  @include main.pn-sr-only-class();

  &-group {
    position: relative;
    padding: 0;
    margin: 0;
  }

  &-input {
    position: relative;

    > pn-icon {
      pointer-events: none;
      position: absolute;
      top: 0.75em;
      right: 3.5em;
      &[data-custom] {
        left: 0.75em;
        right: unset;
      }
    }
  }

  &-button {
    cursor: pointer;
    position: absolute;
    right: 0.75em;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    margin: 0;
    border: 0;
    width: 2em;
    height: 2em;
    font-size: 1em;
    border-radius: 50%;
    background-color: transparent;

    -webkit-tap-highlight-color: transparent;

    @include main.pn-transition('background-color, outline-color, border-color');
    @include main.pn-focus(main.$blue700, main.$white, main.$blue700);

    > pn-icon > svg > path {
      @include main.pn-transition('transform');
      transition-delay: main.$timing;
      transform-origin: center;
      transform: rotate(0deg);
    }

    &:hover {
      background-color: main.$blue25;
    }

    &[aria-expanded='true'] {
      background-color: main.$blue25;
      > pn-icon > svg > path {
        transform: rotate(180deg);
        transition-delay: 0s;
      }
    }
  }

  &-element {
    @include main.pn-input-field;

    cursor: text;
    text-align: left;
    transition-delay: 0.1s, 0.1s, 0s;
    width: 100%;
    padding-right: 3.5em;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5em;

    overflow: hidden;
    text-overflow: ellipsis;

    &:disabled {
      @include main.pn-disabled;
      pointer-events: none;
      + .pn-multiselect-button {
        pointer-events: none;
        path {
          fill: main.$input-color-disabled;
        }
      }
    }

    &:placeholder {
      @include main.pn-placeholder;
    }

    &[type='input']:hover {
      cursor: pointer;
      color: main.$input-color;
      background-color: main.$input-background-hover;
      transition-delay: 0s;
      &[aria-invalid='true'] {
        background-color: main.$input-background-error-hover;
      }
    }

    &:focus-visible {
      transition-delay: 0s;
    }

    &::-webkit-search-cancel-button,
    &::-webkit-search-decoration {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }

  &-options {
    scroll-behavior: smooth;
    position: absolute;
    z-index: 10;
    top: calc(100% + 0.5em);
    left: 0;
    right: 0;
    opacity: 0;
    background-color: main.$white;
    box-shadow:
      0em 0.075em 0.225em 0em rgba(0, 0, 0, 0.1),
      0em 0.4em 0.9em 0em rgba(0, 0, 0, 0.13);

    border-radius: main.$border-radius;

    list-style: none;
    margin: 0;
    padding: 0;

    width: var(--pn-select-options-width);
    max-height: var(--pn-select-max-height);
    overflow-y: auto;
    overflow-x: hidden;

    display: flex;
    flex-direction: column;

    visibility: hidden;

    transform-origin: top left;

    transform: scaleY(0) translateZ(0);

    &[data-moving] {
      @include main.pn-transition('transform, opacity, visibility');
    }

    &[data-open] {
      opacity: 1;
      transform: scaleY(1) translateZ(0);
      visibility: visible;
    }

    &[data-upwards] {
      top: unset;
      bottom: calc(100% + 0.5em);
      transform-origin: bottom left;
      box-shadow: 0 -0.0625em 0.125em rgba(0, 0, 0, 0.2);
    }

    @include main.pn-scrollbar();

    > pn-input {
      padding: 0.5em;
    }
  }

  &-optgroup {
    list-style: none;
    padding: 0;
    > .pn-multiselect-option > .pn-multiselect-option-content {
      padding-left: 2em;
    }
  }

  &-chips {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    padding: 0;
    margin: 0.5em 0 0 0;
    color: main.$gray700;
    font-weight: 400;
    &:empty {
      display: none;
    }
  }

  &-chip {
    margin: 0;
    display: inline-flex;
    align-items: center;
    gap: 0.25em;
    background-color: main.$white;
    border-radius: main.$border-radius;
    padding: 0.125em 0.25em 0.125em 0.5em;
    line-height: 1.5em;
    border: 0.0625em solid main.$gray700;

    @include main.pn-focus-base;
    @include main.pn-transition('background-color, outline-color, border-color, color');

    &:focus-within {
      color: main.$blue700;
      @include main.pn-focus-visible(main.$blue700, main.$blue25, main.$blue700);
    }

    &[data-count] {
      pointer-events: none;
      border: 0;
      padding-left: 0;
      padding-right: 0;
      background-color: unset;
    }

    &-label {
      font-size: 0.875em;
      white-space: nowrap;
    }

    &-button {
      cursor: pointer;
      font-size: 1em;
      padding: 0.25em;
      height: 1.5em;
      width: 1.5em;
      border: 0;
      background-color: unset;
      border-radius: 50%;
      @include main.pn-transition('background-color');
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background-color: main.$blue200;
      }
      &:focus {
        outline: 0;
      }
    }
  }

  &-no-results {
    margin: 0;
    padding: 0.75em;
  }

  &-description {
    @include main.pn-input-helpertext;
    &[role='alert'] {
      color: main.$helpertext-color-error;
    }
  }
}

// Select option
pn-multiselect .pn-multiselect-option {
  position: relative;
  margin: 0;
  padding: 0;
  @include main.pn-ripple(main.$blue700);

  &-input {
    cursor: pointer;
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    margin: 0;
    -webkit-tap-highlight-color: transparent;

    &:disabled {
      pointer-events: none;
      + .pn-multiselect-option-content {
        @include main.pn-disabled;
        pointer-events: none;
        .pn-multiselect-option-checkbox {
          background-color: main.$input-background-disabled;
          border-color: main.$input-border-disabled;
        }
        path {
          fill: main.$input-color-disabled;
        }
      }

      &:checked {
        + .pn-multiselect-option-content {
          @include main.pn-disabled;
          .pn-multiselect-option-checkbox {
            background-color: main.$input-button-disabled;
            border-color: main.$input-border-disabled;
          }
          path {
            fill: main.$input-color-disabled;
          }
        }
      }
    }

    &[aria-invalid='true'] {
      + .pn-multiselect-option-content {
        .pn-multiselect-option-checkbox {
          border-color: main.$border-color-error;
        }
        .pn-ripple {
          background-color: main.$warning;
        }
      }

      &:checked + .pn-multiselect-option-content {
        background-color: main.$input-background-error-active;
        .pn-multiselect-option-checkbox {
          background-color: main.$input-button-active-error;
          border-color: main.$input-button-active-error;
        }
      }

      &:checked:focus-visible + .pn-multiselect-option-content {
        background-color: main.$input-background-error-active;
        .pn-multiselect-option-checkbox {
          background-color: main.$input-button-active-error-focus;
          border-color: main.$input-button-active-error-focus;
        }
      }

      &:checked:hover + .pn-multiselect-option-content {
        background-color: main.$coral25;
        .pn-multiselect-option-checkbox {
          background-color: main.$input-button-active-error-hover;
          border-color: main.$input-button-active-error-hover;
        }
      }

      &:hover + .pn-multiselect-option-content {
        background-color: main.$coral25;
        .pn-multiselect-option-checkbox {
          background-color: main.$input-background-error-hover;
          border-color: main.$border-color-error-focus;
        }
      }

      &:focus-visible + .pn-multiselect-option-content .pn-multiselect-option-checkbox {
        @include main.pn-focus-visible(
          main.$border-color-error-focus,
          main.$input-background-error-active,
          main.$border-color-error-focus
        );
      }
    }

    &:hover + .pn-multiselect-option-content {
      background-color: main.$blue25;
      .pn-multiselect-option-checkbox {
        border-color: main.$blue700;
        background-color: main.$blue50;
      }
    }

    &:focus-visible + .pn-multiselect-option-content .pn-multiselect-option-checkbox {
      @include main.pn-focus-visible(main.$blue700, main.$blue50, main.$blue700);
    }

    &:checked + .pn-multiselect-option-content {
      background-color: main.$blue50;
      .pn-multiselect-option-checkbox {
        border-color: main.$blue700;
        background-color: main.$blue700;
        svg polyline.pn-multiselect-option-checkbox-checkmark-path {
          transition-delay: 0.2s;
          stroke-dashoffset: 0;
        }
      }
    }

    &:checked:hover + .pn-multiselect-option-content {
      background-color: main.$blue25;
      .pn-multiselect-option-checkbox {
        border-color: main.$blue900;
        background-color: main.$blue900;
      }
    }

    &:checked:focus-visible + .pn-multiselect-option-content {
      background-color: main.$blue50;
      .pn-multiselect-option-checkbox {
        border-color: main.$blue900;
        background-color: main.$blue900;
      }
    }

    &:indeterminate + .pn-multiselect-option-content {
      .pn-multiselect-option-checkbox {
        background-color: main.$blue700;
        border-color: main.$blue700;
      }
      svg .pn-multiselect-option-checkbox-checkmark-path {
        stroke-dashoffset: 23;
      }
      svg .pn-multiselect-option-checkbox-indeterminate-path {
        stroke-dashoffset: 0;
      }
    }

    &:indeterminate:hover + .pn-multiselect-option-content {
      .pn-multiselect-option-checkbox {
        background-color: main.$blue900;
        border-color: main.$blue900;
      }
    }
  }

  &-content {
    position: relative;
    overflow: hidden;
    z-index: -1;
    display: flex;
    align-items: center;
    padding: 0.75em 1em;
    gap: 0.5em;
    background-color: main.$white;
    @include main.pn-transition('background-color');
  }

  &-text {
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &-label {
    color: main.$gray900;
    font-weight: 400;
  }

  &-helper {
    color: main.$gray700;
    margin: 0;
  }

  &-checkbox {
    background-color: main.$white;
    flex: 0 0 1.5em;
    width: 1.5em;
    height: 1.5em;
    border: 0.0625em solid main.$gray400;
    border-radius: 0.25em;

    @include main.pn-focus-base;
    @include main.pn-transition('background-color, border-color, outline-color');

    svg polyline {
      stroke: main.$white;
      stroke-linecap: round;
      stroke-dasharray: 23;
      transition: stroke-dashoffset 0.2s main.$easing 0s;

      &.pn-multiselect-option-checkbox-checkmark-path {
        stroke-dashoffset: 23;
      }

      &.pn-multiselect-option-checkbox-indeterminate-path {
        stroke-dashoffset: 23;
      }
    }
  }
}
